import {
  Glass,
  PillChip,
  ScreenLabel,
  DisplayText,
  BodyText,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

export const LDL_DATA = [138, 142, 140, 145, 144, 148];

export function ChatScreen() {
  const BAR_W = 182,
    BAR_H = 44,
    LDL_MIN = 90,
    LDL_MAX = 160;
  const MONTHS = ["Aug", "Sep", "Oct", "Nov", "Dec", "Jan"];

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      {/* Header */}
      <div
        style={{
          padding: "8px 16px 6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexShrink: 0,
        }}
      >
        <DisplayText size={22} color="var(--color-kin-black)" lineHeight={1.1}>
          Kin
        </DisplayText>
        <div
          style={{
            padding: "4px 12px",
            borderRadius: 24,
            background: "rgba(165,144,255,0.15)",
            border: "1px solid rgba(165,144,255,0.3)",
            fontSize: 8.5,
            fontWeight: 800,
            color: "var(--color-kin-lavender)",
            fontFamily: "'Manrope', system-ui",
            letterSpacing: "0.05em",
          }}
        >
          Sleep Deep Dive
        </div>
      </div>

      {/* Context strip */}
      <div
        className="phone-scroll"
        style={{ display: "flex", gap: 6, padding: "0 16px 8px", flexShrink: 0, overflowX: "auto" }}
      >
        {[
          {
            label: "HbA1c 5.8%",
            color: "var(--color-kin-gold-dark)",
            bg: alpha("var(--color-kin-gold)", "15"),
          },
          {
            label: "Vit D 18ng/mL",
            color: "var(--color-kin-orange)",
            bg: alpha("var(--color-kin-orange)", "15"),
          },
          {
            label: "HR 62bpm",
            color: "var(--color-kin-green-soft)",
            bg: alpha("var(--color-kin-green-soft)", "15"),
          },
        ].map((ctx) => (
          <div
            key={ctx.label}
            style={{
              padding: "4px 10px",
              borderRadius: 20,
              background: ctx.bg,
              border: borderAlpha(ctx.color, "40"),
              fontSize: 8.5,
              fontWeight: 800,
              color: ctx.color,
              fontFamily: "'Manrope', system-ui",
              flexShrink: 0,
            }}
          >
            {ctx.label}
          </div>
        ))}
      </div>

      {/* Messages */}
      <div
        style={{
          flex: 1,
          padding: "0 14px",
          display: "flex",
          flexDirection: "column",
          gap: 10,
          overflowY: "hidden",
        }}
      >
        {/* User 1 */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              maxWidth: "75%",
              background: "rgba(254,253,251,0.9)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 4px 12px -4px rgba(0,0,0,0.04)",
              borderRadius: "20px 20px 6px 20px",
              padding: "10px 14px",
            }}
          >
            <BodyText
              size={11}
              color="var(--color-kin-black)"
              weight={600}
              style={{ lineHeight: 1.4 }}
            >
              Can you explain my LDL trend?
            </BodyText>
          </div>
        </div>

        {/* AI 1 — with chart */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "90%",
              background:
                "linear-gradient(135deg, rgba(165,144,255,0.12) 0%, rgba(165,144,255,0.04) 100%)",
              border: "1px solid rgba(165,144,255,0.25)",
              boxShadow: "0 4px 16px -4px rgba(165,144,255,0.1)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
            }}
          >
            <BodyText
              size={11}
              color="var(--color-kin-black)"
              weight={500}
              style={{ lineHeight: 1.45 }}
            >
              Your LDL has trended upward over 6 months — 138 to 148 mg/dL. Borderline, but worth
              monitoring.
            </BodyText>
            {/* Mini bar chart */}
            <div
              style={{
                background: "rgba(254,253,251,0.7)",
                border: "1px solid rgba(0,0,0,0.05)",
                borderRadius: 16,
                padding: "10px 12px",
                marginTop: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 8,
                }}
              >
                <ScreenLabel style={{ letterSpacing: "0.15em" }}>LDL Trend 6M</ScreenLabel>
                <div
                  style={{
                    padding: "2px 8px",
                    borderRadius: 10,
                    background: "rgba(255,138,77,0.15)",
                    fontSize: 8.5,
                    fontWeight: 800,
                    color: "#ff8a4d",
                    fontFamily: "'Manrope', system-ui",
                  }}
                >
                  Upward +6
                </div>
              </div>
              <svg viewBox={`0 0 ${BAR_W} ${BAR_H}`} style={{ width: "100%", height: 40 }}>
                <g>
                  <line
                    x1="0"
                    y1={BAR_H - ((100 - LDL_MIN) / (LDL_MAX - LDL_MIN)) * (BAR_H - 6) - 4}
                    x2={BAR_W}
                    y2={BAR_H - ((100 - LDL_MIN) / (LDL_MAX - LDL_MIN)) * (BAR_H - 6) - 4}
                    stroke="rgba(126, 139, 130, 0.4)"
                    strokeWidth="1"
                    strokeDasharray="2 2"
                  />
                  <text
                    x="0"
                    y={BAR_H - ((100 - LDL_MIN) / (LDL_MAX - LDL_MIN)) * (BAR_H - 6) - 8}
                    fill="var(--color-kin-muted)"
                    fontSize="7"
                    fontWeight="700"
                    fontFamily="'Manrope', system-ui"
                  >
                    Normal &lt;100
                  </text>
                </g>
                {LDL_DATA.map((v, i) => {
                  const barW = 22;
                  const gap = (BAR_W - LDL_DATA.length * barW) / (LDL_DATA.length - 1);
                  const x = i * (barW + gap);
                  const barH = ((v - LDL_MIN) / (LDL_MAX - LDL_MIN)) * (BAR_H - 6) + 4;
                  const y = BAR_H - barH;
                  const isLast = i === LDL_DATA.length - 1;
                  return (
                    <rect
                      key={i}
                      x={x}
                      y={y}
                      width={barW}
                      height={barH}
                      rx="4"
                      fill={isLast ? "#ff8a4d" : "rgba(255,138,77,0.3)"}
                    />
                  );
                })}
              </svg>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
                {MONTHS.map((m) => (
                  <BodyText key={m} size={8} color="var(--color-kin-muted)" weight={700}>
                    {m}
                  </BodyText>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* User 2 */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              maxWidth: "75%",
              background: "rgba(254,253,251,0.9)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 4px 12px -4px rgba(0,0,0,0.04)",
              borderRadius: "20px 20px 6px 20px",
              padding: "10px 14px",
            }}
          >
            <BodyText size={11} color="var(--color-kin-black)" weight={600}>
              What should I do about it?
            </BodyText>
          </div>
        </div>

        {/* AI 2 */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "85%",
              background:
                "linear-gradient(135deg, rgba(165,144,255,0.12) 0%, rgba(165,144,255,0.04) 100%)",
              border: "1px solid rgba(165,144,255,0.25)",
              boxShadow: "0 4px 16px -4px rgba(165,144,255,0.1)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            {[
              "1. Reduce saturated fat in daily diet.",
              "2. Add 30min cardio 3\u00d7 per week.",
              "3. Recheck labs in 8 weeks.",
            ].map((item) => (
              <BodyText key={item} size={11} color="var(--color-kin-black)" weight={500}>
                {item}
              </BodyText>
            ))}
          </div>
        </div>

        {/* AI tracker suggestion */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              maxWidth: "92%",
              background:
                "linear-gradient(135deg, rgba(165,144,255,0.12) 0%, rgba(165,144,255,0.04) 100%)",
              border: "1px solid rgba(165,144,255,0.25)",
              boxShadow: "0 4px 16px -4px rgba(165,144,255,0.1)",
              borderRadius: "6px 20px 20px 20px",
              padding: "12px 14px",
            }}
          >
            <BodyText
              size={11}
              color="var(--color-kin-black)"
              weight={500}
              style={{ marginBottom: 10, lineHeight: 1.45 }}
            >
              To track this properly, I'd suggest logging your diet daily. Your LDL data becomes
              much more actionable with meal context.
            </BodyText>
            <div
              style={{
                background: "rgba(254,253,251,0.8)",
                border: "1px solid rgba(255,208,40,0.4)",
                borderRadius: 16,
                padding: "10px 12px",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 14,
                  background: "rgba(255,208,40,0.2)",
                  border: "1px solid rgba(255,208,40,0.4)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 0 8px rgba(255,208,40,0.3)",
                }}
              >
                <BodyText size={9} color="#f0b800" weight={800} style={{ letterSpacing: "0.08em" }}>
                  DI
                </BodyText>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <BodyText
                  size={10}
                  color="var(--color-kin-black)"
                  weight={800}
                  style={{ marginBottom: 2 }}
                >
                  Diet Tracker
                </BodyText>
                <BodyText size={8.5} color="var(--color-kin-muted)" weight={500}>
                  Daily · takes 30 sec
                </BodyText>
              </div>
              <div
                style={{
                  background: "rgba(255,208,40,0.2)",
                  border: "1px solid rgba(255,208,40,0.4)",
                  borderRadius: 24,
                  padding: "6px 14px",
                  flexShrink: 0,
                }}
              >
                <BodyText size={9} color="#f0b800" weight={800}>
                  Set up
                </BodyText>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick prompts */}
      <div style={{ position: "relative", flexShrink: 0, marginTop: 4 }}>
        <div
          className="phone-scroll"
          style={{
            padding: "6px 14px",
            display: "flex",
            gap: 8,
            overflowX: "auto",
            scrollbarWidth: "none",
          }}
        >
          {["Explain my sleep", "Build a plan", "Doctor questions"].map((p) => (
            <PillChip key={p} color="var(--color-kin-green-soft)">
              {p}
            </PillChip>
          ))}
        </div>
        <div
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            width: 32,
            background: "linear-gradient(to right, rgba(245,251,247,0), var(--color-kin-cream))",
            pointerEvents: "none",
          }}
        />
      </div>

      {/* Input */}
      <div style={{ padding: "6px 14px 0", flexShrink: 0 }}>
        <Glass
          style={{
            padding: "8px 10px 8px 16px",
            display: "flex",
            alignItems: "center",
            gap: 10,
            borderRadius: 28,
            boxShadow: "0 4px 16px -4px rgba(0,0,0,0.06)",
          }}
        >
          <BodyText size={11} color="var(--color-kin-muted)" weight={500} style={{ flex: 1 }}>
            Ask about your health…
          </BodyText>
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              background: "var(--color-kin-green-soft)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              boxShadow: "0 2px 8px rgba(91,122,102,0.4)",
            }}
          >
            <span
              style={{
                color: "var(--color-kin-white)",
                fontSize: 14,
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              ↑
            </span>
          </div>
        </Glass>
      </div>
    </div>
  );
}
